import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Grow, Grid } from '@material-ui/core'
// import { API_URL, URL } from '../../constants/actionTypes'
import FormEditColorMixing from '../Form/FormEditColorMixing'
const EditColorMixing = () => {
  // const navigate = useNavigate()
  //const loginSuccess = JSON.parse(localStorage.getItem('colorMixing'))
  useEffect(() => {
    // if (!loginSuccess) {
    //   navigate(URL + '/login')
    // }
  }, [])
  return (
    <Grow in>
      <Container>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
        >
          <Grid item xs={12} sm={12}>
            <FormEditColorMixing />
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}

export default EditColorMixing
